import _ from 'underscore';

import {graphQLArrayToREST} from 'graphql-client/declarative-translations/external/translate';
import {AssaySchema} from 'results/assay-schemas/AssaySchemaConstants';
import {dispatchAssaySchemasUpdatedFromGQL} from 'results/AssaySchemaActions';
import AssayStore from 'results/AssayStore';

import {SampleGroupSchemaGraphQL} from '../../../../graphql-fragments/requests/schemas/__generated/SampleGroupSchemaGraphQL';
import Syncer from '../Syncer';

// SampleGroupSchema is an interesting model since in REST contexts, it's always lived as a nested object on
// RequestSchema. This means that for the most part, our other syncers should cover it. The only situations
// that could update a SampleGroupSchema outside of that are queries that bypass RequestSchema, for example
// fragment F on SampleGroup { schema { ...SampleGroupSchema } }
// For completeness, we include this syncer, though given how static SampleGroupSchemas tend to be, it's quite
// believable that by the time we end up deleting syncers, this won't have made any difference.
export default class SampleGroupSchemaSyncer extends Syncer<void, SampleGroupSchemaGraphQL> {
  override shouldSubscribeToRedux = false;

  readFromStore(): void {}

  writeToApolloCache(): void {}

  writeToStore(graphQLModels: Array<SampleGroupSchemaGraphQL>): void {
    const requestSchemas = AssayStore.getRequestSchemas('SampleGroupSchemaSyncer');
    if (requestSchemas) {
      // It's possible we load a GraphQL SampleGroupSchema this way for a RequestSchema that isn't in the
      // store yet. In that case, don't insert it into the store (since we don't have the corresponding
      // RequestSchema).
      const requestSchemasWithSampleGroupSchemas = requestSchemas.filter(
        (reqSchema) => reqSchema.sampleGroupSchema != null
      );
      const sampleGroupSchemaIdToReqSchema = _.indexBy(
        requestSchemasWithSampleGroupSchemas,
        (reqSchema) => reqSchema.sampleGroupSchema!.id
      );

      const sampleGroupSchemas = graphQLArrayToREST(
        'SampleGroupSchema',
        graphQLModels.filter((gqlSampleGroupSchema) =>
          sampleGroupSchemaIdToReqSchema.hasOwnProperty(gqlSampleGroupSchema.id)
        )
      );

      const updatedRequestSchemas = sampleGroupSchemas.map((sampleGroupSchema) => ({
        ...sampleGroupSchemaIdToReqSchema[sampleGroupSchema.id],
        sampleGroupSchema: {...sampleGroupSchema},
      }));

      dispatchAssaySchemasUpdatedFromGQL(updatedRequestSchemas as Array<AssaySchema>);
    }
  }
}
